import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 sm:bottom-20 right-4 sm:right-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.ids.size > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass([
          { 'animate-bounce': _ctx.doBounce },
          'relative',
          'inline-flex',
          'rounded-md',
          'shadow-sm'
        ])
          }, [
            _createElementVNode("button", {
              class: "inline-flex items-center rounded-lg bg-violet-700 hover:bg-violet-500 focus:outline-none focus:border-violet-700 text-white p-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toLitReview()))
            }, [
              _createTextVNode(" Add Papers (" + _toDisplayString(_ctx.ids.size) + ") ", 1),
              _createVNode(_component_ArrowRightIcon, { class: "w-4 h-4 ml-2" })
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}